import React from 'react';
import { Shirt, Briefcase, Flame, Truck, Award, Clock } from 'lucide-react';
import './Services.css';

const Services = () => {
  const services = [
    {
      id: 1,
      icon: Shirt,
      title: 'Textile de Qualité',
      description: 'Large gamme de vêtements et textiles de haute qualité pour professionnels et particuliers. Des matériaux soigneusement sélectionnés pour leur durabilité et leur confort.'
    },
    {
      id: 2,
      icon: Briefcase,
      title: 'Maroquinerie & Bagagerie',
      description: 'Articles en cuir véritable et bagages de qualité, fabriqués avec soin et attention aux détails. Chaque pièce est sélectionnée pour son authenticité et sa qualité exceptionnelle.'
    },
    {
      id: 3,
      icon: Flame,
      title: 'Combustibles',
      description: 'Solutions de chauffage écologiques et performantes incluant pellets de bois de première qualité, avec taux d\'humidité contrôlé pour votre confort.'
    },
    {
      id: 4,
      icon: Truck,
      title: 'Livraison Rapide',
      description: 'Service de livraison fiable et rapide pour tous vos produits. Nous assurons un transport sécurisé dans les meilleurs délais.'
    },
    {
      id: 5,
      icon: Award,
      title: 'Qualité Garantie',
      description: 'Tous nos produits sont rigoureusement sélectionnés et contrôlés pour vous garantir une qualité irréprochable et une satisfaction totale.'
    },
    {
      id: 6,
      icon: Clock,
      title: 'Service Client Réactif',
      description: 'Équipe disponible et à votre écoute pour répondre à toutes vos questions et vous accompagner dans vos choix.'
    }
  ];

  return (
    <div className="services">
      <div className="services-hero">
        <div className="container">
          <h1 className="heading-primary">Nos Services</h1>
          <p className="services-description">
            Découvrez l&apos;ensemble de nos services et notre engagement qualité
          </p>
        </div>
      </div>

      <div className="services-content section-padding">
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => {
              const Icon = service.icon;
              return (
                <div
                  key={service.id}
                  className="service-card premium-card fade-in-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="service-icon">
                    <Icon size={32} />
                  </div>
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <section className="why-choose-section">
        <div className="container">
          <h2 className="heading-secondary">Pourquoi choisir Phoenix Negoce ?</h2>
          <div className="why-grid">
            <div className="why-item">
              <h3>Excellence</h3>
              <p>Des produits sélectionnés avec rigueur pour leur qualité exceptionnelle</p>
            </div>
            <div className="why-item">
              <h3>Fiabilité</h3>
              <p>Un partenaire de confiance pour tous vos besoins professionnels</p>
            </div>
            <div className="why-item">
              <h3>Expertise</h3>
              <p>Une connaissance approfondie de nos produits et de votre secteur</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;